import { Input, Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { EventBean } from '../../../beansts/Event';
import {AppDataService} from "../../../services/app-data.service";
import {InstagramUserBean} from "../../../beansts/instagram.user.bean";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';

declare let $: any;
declare var Swal : any;

@Component({
    selector : 'game-userlogin-modal',
    templateUrl:'game-userlogin-component.html',
})
export class GameUserLoginModalComponent implements OnInit, OnDestroy{

  public gender='M';
  public avatars=["h1.png","h2.png","h3.png","h4.png","h5.png","h6.png","h7.png","h8.png"]
  public avatarId=0;
  public basicInfoForm
  public loginInfoForm
  public tab=1;
  public lang='en'

  private user : InstagramUserBean;
  public constructor( private _router : Router,public _appData : AppDataService,public translate: TranslationService,private fb : FormBuilder, private _companyService : CompanyService) {
    this.basicInfoForm = this.fb.group({
      userPolicy : false,
      userEmail: '',
      userPassword:'',
      userName:'',
      userPasswordConfirm:'',
      chkMasculine:true,
      chkFeminine:false,
      chkKid:false
    });
    this.loginInfoForm = this.fb.group({
      userEnterEmail: '',
      userEnterPassword:'',

    });

  }
  public login=true;
  public register=false
  public flipLogin(str){
    if (str=='login'){
      this.login=true;
      this.register=false

    }
    if (str=='register'){
      this.login=false;
      this.register=true
    }
  }
    public setTab(tab){
      this.tab=tab;
    }
    public setSex(sex){
      this.gender=sex;
    }
    public selectLanguage(lang){
      this.lang=lang
    }

    public ngOnInit(): any {
      this.basicInfoForm = this.fb.group({
        userPolicy : false,
        userEmail: '',
        userPassword:'',
        userName:'',
        userPasswordConfirm:'',
        chkMasculine:true,
        chkFeminine:false,
        chkKid:false
  
     });
     this.loginInfoForm = this.fb.group({
      userEnterEmail: '',
      userEnterPassword:'',

    });

    }

    public ngOnDestroy() : any {
    }


    public forgetPassword(){
      let userEmail : string      = this.loginInfoForm.controls['userEnterEmail'].value;
      if (userEmail==null || userEmail.length==0){
        Swal.fire(this.translate.instant('GAME_USERLOGIN_COMPONENT_11'))
        return;
      }   
      this._companyService.forgetPassword(userEmail).then((val)=>{
        Swal.fire(this.translate.instant('GAME_USERLOGIN_COMPONENT_12'))
      }).catch(err=>{
        Swal.fire(this.translate.instant('GAME_USERLOGIN_COMPONENT_13'))
      }     
        );
    }
  
    public close(){
      $('#registerSocialModal').modal('hide')
    }
  //user decided to register himself
    public updateUserData(){
      let userName : string      = this.basicInfoForm.controls['userName'].value;
      let userEmail : string      = this.basicInfoForm.controls['userEmail'].value;
      let userPassword : string = this.basicInfoForm.controls['userPassword'].value;
      let userConfirmPassword : string = this.basicInfoForm.controls['userPasswordConfirm'].value;
      let userPolicy : boolean = this.basicInfoForm.controls['userPolicy'].value;


      if (!userPolicy){
        Swal.fire({
          title: this.translate.instant('FAIL'),
          text: "Você precisa ler e aceitar nossa política de uso de dados para se cadastrar",
          confirmButtonColor: '#CFA349',
          confirmButtonText: 'OK'
        })
        return;

      }
        if (!userName || userName.length==0){
          Swal.fire({
            title: this.translate.instant('FAIL'),
            text: this.translate.instant('GAME_USERLOGIN_COMPONENT_14'),
            confirmButtonColor: '#CFA349',
            confirmButtonText: 'OK'
          })
          return;
        }

      if (!userEmail || userEmail.length==0){
        Swal.fire({
          title: this.translate.instant('FAIL'),
          text: this.translate.instant('GAME_USERLOGIN_COMPONENT_15'),
          confirmButtonColor: '#CFA349',
          confirmButtonText: 'OK'
        })
        return;
      }
      if (userPassword.length<8){
        Swal.fire({
          title: this.translate.instant('FAIL'),
          text: this.translate.instant('GAME_USERLOGIN_COMPONENT_16'),
          confirmButtonColor: '#CFA349',
          confirmButtonText: 'OK'
        })
        return;
      }
        if (userPassword != userConfirmPassword){
          Swal.fire({
            title: this.translate.instant('FAIL'),
            text: this.translate.instant('GAME_USERLOGIN_COMPONENT_17'),
            confirmButtonColor: '#CFA349',
            confirmButtonText: 'OK'
          })
          return;
        }
        let checkTerm


        this._companyService.registerUser(userEmail,userPassword).then((result) => {
          let uid=result.user.uid;
   
          let body=this._companyService.getAvatar();


          
          let rid=Math.floor(Math.random() * 5);
          let avatar='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fh0.png?alt=media&token=06662e87-0614-40b5-a0d2-9f454977429d'
          if (this.gender=='M'){
            switch (rid){
              case 0: {
                avatar='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fh0.png?alt=media&token=06662e87-0614-40b5-a0d2-9f454977429d'
                break
              }
              case 1: {
                avatar='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fh1.png?alt=media&token=4d650af7-5293-408c-b892-53386d083834'
                break
              }
              case 2: {
                avatar='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fh2.png?alt=media&token=ebef7b3f-4c5c-4fa6-ab94-c5c1ffaaed46'
                break
              }
              case 3: {
                avatar='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fh3.png?alt=media&token=642ed906-c0d6-4a3c-ae9d-39b060fd0537'
                break
              }
              case 4: {
                avatar='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fh4.png?alt=media&token=df7d4ccf-4163-4e5a-a39e-321260e8c1a8'
                break
              }
              case 5: {
                avatar='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fh5.png?alt=media&token=d2bca78d-04db-4691-975f-071536939fc1'
                break
              }
            }
          }
          else if (this.gender=='F') {
            switch (rid){
              case 0: {
                avatar='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fm0.png?alt=media&token=44dd7a5f-9480-482a-b84b-5ce0e5857f7a'
                break
              }
              case 1: {
                avatar='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fm1.png?alt=media&token=74025f98-823b-4331-bbcf-9a6bf28e960c'
                break
              }
              case 2: {
                avatar='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fm2.png?alt=media&token=fffb343c-b8cd-4a76-a774-1004e3aecc92'
                break
              }
              case 3: {
                avatar='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fm3.png?alt=media&token=8de25c7e-8aa4-4990-b7e2-ca265f1d1173'
                break
              }
              case 4: {
                avatar='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fm4.png?alt=media&token=f57450c7-b2b0-4ce1-b6bf-3a320b342d6b'
                break
              }
              case 5: {
                avatar='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fm5.png?alt=media&token=9a3e9d1d-1ea7-4d71-a191-0d0bd4b6af85'
                break
              }
            }
          }
        /*  else if (chkKid){
            avatar=body.child.default
          }*/
          else{
            switch (rid){
              case 0: {
                avatar='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fh0.png?alt=media&token=06662e87-0614-40b5-a0d2-9f454977429d'
                break
              }
              case 1: {
                avatar='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fh1.png?alt=media&token=4d650af7-5293-408c-b892-53386d083834'
                break
              }
              case 2: {
                avatar='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fh2.png?alt=media&token=ebef7b3f-4c5c-4fa6-ab94-c5c1ffaaed46'
                break
              }
              case 3: {
                avatar='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fh3.png?alt=media&token=642ed906-c0d6-4a3c-ae9d-39b060fd0537'
                break
              }
              case 4: {
                avatar='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fh4.png?alt=media&token=df7d4ccf-4163-4e5a-a39e-321260e8c1a8'
                break
              }
              case 5: {
                avatar='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Fh5.png?alt=media&token=d2bca78d-04db-4691-975f-071536939fc1'
                break
              }
            }
          }
          let event =this._appData.event;
          if (!event) {
            event=new EventBean();
            event.id=1592880902713
            event.room='1644803653158'
          }
          if (!event.room) event.room='1644803653158'
          if (this._appData.instagramUser){
            if (this._appData.instagramUser.room){
              event.room=this._appData.instagramUser.room;
            } 
          }
          if (!event.id) event.id=1592880902713
          let date=new Date();
          let time=date.getTime();
            let user={
              uid: uid,
              full_name:userName,
              email:userEmail,
              sex:this.gender,
              event:event.id.toString(),
              room:event.room,
              avatarVersion:3,
              userPolicyChecked:userPolicy,
              userPolicyCheckdTime: time,
              avatar:avatar,
              lang:this.lang,
              hair:'black',
              bodyColor:'white',
              profile_picture:'https://liveplanet.app.br/assets/landingstyle/profile.png',
              status:0
          }
          this._companyService.updateProfile(user).then((res)=>{
            this._appData.instagramUser=user;
            this._appData.profilePicture=user.profile_picture;
            let myuser=user;
            if (typeof window !== "undefined" && localStorage) {localStorage.setItem('instagramUser',JSON.stringify(myuser))}
            $('#registerSocialModal').modal('hide');



            let domain=window.location.origin


            if (window.location.pathname.indexOf('social')>0){
              return;
            }
              if (this._appData.page=='' || this._appData.page=='portal'){
                if (!this._appData.instagramUser.event || this._appData.instagramUser.event!='1592880902713'){
                  this._appData.instagramUser.event='1592880902713'
                  this._appData.instagramUser.room='1644803653158' 
                }   
                $('#main').css('height','');
                let domain=window.location.origin
                window.location.href = domain+"/game/"; 
              }
              else if (this._appData.page=='eventdetail'){
                let event = this._appData.event;
                let date=new Date();
                let milis=date.getTime();
                this._companyService.addToEvent(this._appData.instagramUser.uid,event);         
                /*}
                else{
                  let user=this._appData.instagramUser;
                  this._companyService.addToLove(event,user).then((val)=>{
                    Swal.fire('Vamos lá então!!','Você está na lista dos participantes do evento. Quando o evento começar clique em ENTRAR NO EVENTO')
                    $("#updateEventUserList").click();
                  })
                } */
              }
              else if (this._appData.page=='meeting'){
                window.location.replace(domain+"/meeting/"+this._appData.event.id+"?room="+this._appData.room.id);
              } 
              else if (this._appData.page=='welcome'){
                //dont do nothing stay at the same page
                Swal.fire({title:this.translate.instant('GAME_USERLOGIN_COMPONENT_18'),
                text:this.translate.instant('GAME_USERLOGIN_COMPONENT_19'),
                confirmButtonText: this.translate.instant('YES'),
                cancelButtonText:this.translate.instant('NO'),
                showCloseButton: true,
                showCancelButton: true,
                focusConfirm: false, 
                }).then((result) => {
                  if (result.dismiss=='backdrop') {}
                  else if (result.dismiss=='close') {}
                  else if (result.dismiss=='cancel'){}
                  else{
                    $('#noAvatarModal').modal("show")
                    $('#redrawAvatar').click() 
                  }})
              }
              else if (this._appData.page=='dashboard'){
                window.location.replace(domain+"/eventdashboard/"+this._appData.event.id+"?evt="+this._appData.dashboardEvent.id);
              }
              else if (this._appData.page=='speakerroom'){
                window.location.replace(domain+"/eventdashboard/"+this._appData.event.id+"?evt="+this._appData.dashboardEvent.id);
              }
              else{
                window.location.replace(domain+"/gameevent/"+this._appData.event.id+"?room="+this._appData.instagramUser.room);
              }
              if (this._appData.vr){
                this._appData.gameUrl="/gamevr.html?uid="+this._appData.instagramUser.uid+"&room="+this._appData.room.id+"&lg=pt"     
              }
              else{
                this._appData.gameUrl="/game.html?uid="+this._appData.instagramUser.uid+"&room="+this._appData.room.id+"&lg=pt"
              }
    

          });
        }).catch(
          (err)=>{
            Swal.fire({
              title: this.translate.instant('FAIL'),
              text: this.translate.instant('GAME_USERLOGIN_COMPONENT_20'),
              confirmButtonColor: '#CFA349',
              confirmButtonText: 'OK'
            })
          }
        );
    
      
    }
    public loginUserData(){
      let userEmail : string      = this.loginInfoForm.controls['userEnterEmail'].value;
      let userPassword : string = this.loginInfoForm.controls['userEnterPassword'].value;
       if (!userEmail || userEmail.length==0){
        Swal.fire({
          title: this.translate.instant('FAIL'),
          text: this.translate.instant('GAME_USERLOGIN_COMPONENT_15'),
          confirmButtonColor: '#CFA349',
          confirmButtonText: 'OK'
        })
        return;
      }
      if (userPassword.length<8){
        Swal.fire({
          title: this.translate.instant('FAIL'),
          text: this.translate.instant('GAME_USERLOGIN_COMPONENT_16'),
          confirmButtonColor: '#CFA349',
          confirmButtonText: 'OK'
        })
        return;
      }
      $('#registerSocialModal').modal('hide')
      this._companyService.authenticateEmailPassword(userEmail,userPassword).then((result) => {
          let uid=result.user.uid;
          this._companyService.getUserByUid(uid).then((user)=>{
            let myuser=user.data();
            this._appData.profilePicture=myuser.profile_picture;
            if (typeof window !== "undefined" && localStorage){
              localStorage.setItem('instagramUser',JSON.stringify(myuser))
            }
            if (this._appData.instagramUser){
              if (this._appData.instagramUser.room){
                myuser.room=this._appData.instagramUser.room;
              } 
            }
  
            this._appData.instagramUser=myuser;
            let date=new Date();
            let milis=date.getTime();
            let domain=window.location.origin
            if (window.location.pathname.indexOf('social')>0){
              return;
            }

            if (this._appData.page=='' || this._appData.page=='portal'){
              if (!this._appData.instagramUser.event || this._appData.instagramUser.event!='1592880902713'){
                this._appData.instagramUser.event='1592880902713'
                this._appData.instagramUser.room='1644803653158' 
              }   
              $('#main').css('height','');
              let domain=window.location.origin
              if (this._appData.room){
                window.location.replace(domain+"/gameevent/1592880902713?room="+this._appData.room.id);
              }
              else{
                window.location.replace(domain+"/game");
              }



            }
            else if (this._appData.page=='eventdetail'){
              let event = this._appData.event;
                this._companyService.addToEvent(this._appData.instagramUser.uid,event);    
                if (this._appData.vr){
                  this._appData.gameUrl="/gamevr.html?uid="+this._appData.instagramUser.uid+"&room="+this._appData.room.id+"&lg=pt"     
                }
                else{
                  this._appData.gameUrl="/game.html?uid="+this._appData.instagramUser.uid+"&room="+this._appData.room.id+"&lg=pt"
                }
      
  
    
              /*}
              else{
                let user=this._appData.instagramUser;
                this._companyService.addToLove(event,user).then((val)=>{
                  Swal.fire('Vamos lá então!!','Você está na lista dos participantes do evento. Quando o evento começar clique em ENTRAR NO EVENTO')
                  $("#updateEventUserList").click();
                })
              //} */
            }
            else if (this._appData.page=='meeting'){
              window.location.replace(domain+"/meeting/"+this._appData.event.id+"?room="+this._appData.room.id);
            }
            else if (this._appData.page=='welcome'){
              //dont do nothing stay at the same page
              Swal.fire({title:this.translate.instant('GAME_USERLOGIN_COMPONENT_21'),
              text:this.translate.instant('GAME_USERLOGIN_COMPONENT_19'),
              confirmButtonText: this.translate.instant('YES'),
              cancelButtonText:this.translate.instant('NO'),
              showCloseButton: true,
              showCancelButton: true,
              focusConfirm: false, 
              }).then((result) => {
                if (result.dismiss=='backdrop') {}
                else if (result.dismiss=='close') {}
                else if (result.dismiss=='cancel'){}
                else{
                  $('#noAvatarModal').modal('show')
                  $('#redrawAvatar').click() 
                }})
            }
            else if (this._appData.page=='social'){
              window.location.replace(domain+"/social");
            }
            else if (this._appData.page=='dashboard'){
              window.location.replace(domain+"/eventdashboard/"+this._appData.event.id+"?evt="+this._appData.dashboardEvent.id);
            }
            else if (this._appData.page=='speakerroom'){
              window.location.replace(domain+"/eventdashboard/"+this._appData.event.id+"?evt="+this._appData.dashboardEvent.id);
            }
            else{
              window.location.replace(domain+"/gameevent/"+this._appData.event.id+"?room="+this._appData.instagramUser.room);
            }

          }).catch(err=>{
            $('#registerSocialModal').modal('hide')
            Swal.fire({
              title: this.translate.instant('FAIL'),
              text: this.translate.instant('GAME_USERLOGIN_COMPONENT_22'),
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'OK'
            })
  
          });
        }).catch(err=>{
          $('#registerSocialModal').modal('hide')
            let el=err.code
            if (el.indexOf('wrong-password')>0){
              Swal.fire({
                title: this.translate.instant('FAIL'),
                text: this.translate.instant('GAME_USERLOGIN_COMPONENT_23'),
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK'
              })
              }
            if (el.indexOf('user-not-found')>0){
              Swal.fire({
                title: this.translate.instant('FAIL'),
                text: this.translate.instant('GAME_USERLOGIN_COMPONENT_24'),
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK'
              })
            }
            if (el.indexOf('too-many-requests')>0){
              Swal.fire({
                title: this.translate.instant('FAIL'),
                text: this.translate.instant('GAME_USERLOGIN_COMPONENT_25'),
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK'
              })
            }
    
  

        });
  
      }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+easylogin/userlogin/game-userlogin-component.ts